import React from 'react';

const AttendanceTable = ({ attendances, openEdit, handleDelete }) => (
  <div className="admins-table-scroll">
    <table className="admins-table students-table">
      <thead>
        <tr>
          <th>Student</th>
          <th>Class</th>
          <th>Section</th>
          <th>Date</th>
          <th>Status</th>
          <th>Remarks</th>
          <th>Created By</th>
          <th>Updated By</th>
          <th>Created Date</th>
          <th>Updated Date</th>
          <th className="actions-header">Actions</th>
        </tr>
      </thead>
      <tbody>
        {attendances.map(attendance => (
          <tr key={attendance._id}>
            <td>{attendance.student ? attendance.student.name : 'N/A'}</td>
            <td>{attendance.student ? attendance.student.class : 'N/A'}</td>
            <td>{attendance.student ? attendance.student.section : 'N/A'}</td>
            <td>{attendance.date && new Date(attendance.date).toLocaleDateString()}</td>
            <td>
              <span className={`status-badge status-${attendance.status.toLowerCase()}`}>
                {attendance.status}
              </span>
            </td>
            <td>{attendance.remarks || 'N/A'}</td>
            <td>{attendance.createdBy ? attendance.createdBy.name : 'N/A'}</td>
            <td>{attendance.updatedBy ? attendance.updatedBy.name : 'N/A'}</td>
          <td>{attendance.createdAt ? new Date(attendance.createdAt).toLocaleString() : 'N/A'}</td>
          <td>{attendance.updatedAt ? new Date(attendance.updatedAt).toLocaleString() : 'N/A'}</td>
            <td>
              <div className="admin-actions">
                <button className="edit-btn" onClick={() => openEdit(attendance)}>Edit</button>
                <button className="delete-btn" onClick={() => handleDelete(attendance._id)}>Delete</button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default AttendanceTable;
